import { render } from "./Alert.vue?vue&type=template&id=6719b733"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"
script.render = render

export default script